import {useState, useEffect} from 'react';
import TimerUtil from '../../../utils/timer';

export default ({
    timestamp,
    button,
    onClick
}) => {
    const [time, setTime] = useState(timestamp - Date.now()),
          timer = TimerUtil.parse(time, true);

    useEffect(() => {
        if(time > 0)
            window.emailConfirmationTimer = setTimeout(() => {
                setTime(timestamp - Date.now())
            }, 500);

        return () => clearTimeout(window.emailConfirmationTimer);
    }, [time]);

    useEffect(() => {
        setTime(timestamp - Date.now());
    }, [timestamp])

    if(time > 0)
        return (
            <div className="button resend" onClick={onClick} style={{
                cursor: 'no-drop',
                opacity: 0.8
            }}>
                Resend code ({timer.minutes}:{timer.seconds})
            </div>
        )

    return (
        <div className="button resend" style={{
            cursor: button ? 'no-drop' : 'pointer'
        }} onClick={onClick}>
            {button ? 'Please wait...' : 'Resend code'}
        </div>
    )
}